"use strict";

var _interopRequireWildcard = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exceljs = _interopRequireDefault(require("exceljs"));
var FileSaver = _interopRequireWildcard(require("file-saver"));
var _default = exports.default = {
  name: 'BasisDownloadExcel',
  // 导出excel文件
  props: {
    // 要导出的数据
    data: {
      type: Array,
      default: () => []
    },
    // 要导出的数据表头
    columns: {
      type: Array,
      default: () => []
    },
    // Mime type
    type: {
      type: String,
      default: 'xlsx'
    },
    // 要导出的 JSON 对象内的字段(表头设置)。如果没有提供，JSON 中的所有属性都将被导出
    fields: {
      type: Object,
      default: undefined // { '姓名' : 'name', '性别' : 'sex' }
    },
    // 要导出的文件名
    name: {
      type: String,
      default: 'data.xlsx'
    },
    // 数据的标题。可以是字符串（一个标题）或字符串数​​组（多个标题）
    header: {
      type: [Array, String],
      default: ''
    },
    // 工作表选项卡的名称
    sheetName: {
      type: String,
      default: 'Sheet1'
    },
    // 工作簿的属性配置
    worksheetOptions: {
      type: Object,
      default: () => {
        return {
          views: [{
            state: 'frozen',
            xSplit: 1,
            ySplit: 1
          }]
        };
      }
    }
  },
  methods: {
    // eslint-disable-next-line max-statements
    exportExcel() {
      const {
        fields,
        data,
        name,
        header,
        type,
        sheetName,
        worksheetOptions
      } = this;
      const ExcelJSWorkbook = new _exceljs.default.Workbook();
      const worksheet = ExcelJSWorkbook.addWorksheet(sheetName);
      let columnsData = [];
      if (fields) {
        columnsData = Object.keys(fields).map(item => ({
          header: item,
          key: fields[item],
          width: 12
        }));
      } else {
        columnsData = Object.keys(data[0]).map(item => ({
          header: item,
          key: item
        }));
      }
      worksheet.columns = columnsData;
      worksheet.addRows(data);
      const isString = str => Object.prototype.toString.call(str) === '[object String]';
      const isArray = arr => Object.prototype.toString.call(arr) === '[object Array]';
      let headers = [];
      if (isString(header) && header) headers = [header];
      if (isArray(header) && header.length > 0) headers = header;
      headers.forEach((item, index) => {
        worksheet.insertRow(index + 1, {
          [columnsData[0].key]: item
        });
        // 按开始行，开始列，结束行，结束列合并
        worksheet.mergeCells(index + 1, 1, index + 1, columnsData.length);
        const row = worksheet.getRow(index + 1);
        row.font = {
          bold: true
        };
        row.alignment = {
          horizontal: 'center'
        };
      });
      const row = worksheet.getRow(headers.length + 1);
      row.font = {
        bold: true
      };
      row.alignment = {
        horizontal: 'center'
      };

      // 外部传入的值
      Object.keys(worksheetOptions).map(key => worksheet[key] = worksheetOptions[key]);
      ExcelJSWorkbook.xlsx.writeBuffer().then(buffer => {
        FileSaver.saveAs(new Blob([buffer], {
          type: 'application/octet-stream'
        }), name.endsWith(type) ? name : `${name}.${type}`);
      });
    }
  }
};